var map = {
	"./title-carousel.de-CH.json": 1312,
	"./title-carousel.de-DE.json": 1313,
	"./title-carousel.en-CA.json": 1314,
	"./title-carousel.en-GB.json": 1315,
	"./title-carousel.en-IN.json": 1316,
	"./title-carousel.en-ME.json": 1317,
	"./title-carousel.en-US.json": 1318,
	"./title-carousel.es-EM.json": 1319,
	"./title-carousel.es-ES.json": 1320,
	"./title-carousel.fr-BE.json": 1321,
	"./title-carousel.fr-CA.json": 1322,
	"./title-carousel.fr-CH.json": 1323,
	"./title-carousel.nl-BE.json": 1324,
	"./title-carousel.nl-NL.json": 1325,
	"./title-carousel.pl-PL.json": 1326,
	"./title-carousel.pt-BR.json": 1327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1311;